import { render, staticRenderFns } from "./rebateDealApproval.vue?vue&type=template&id=56ef1d9a"
import script from "./rebateDealApproval.vue?vue&type=script&lang=js"
export * from "./rebateDealApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports